import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { className: "MuiSvgIcon-root", width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 12.75H21V11.25H3V12.75Z" }));
export default SvgMinus;
